<template>
    <span
        class="bracket-type-badge bracket-type-badge-three-competitor-repechage"
        v-if="fight.bracketType === BracketTypeEnum.ThreeCompetitorRepechage"
    >
        {{ translate("category_label.three_competitor_repechage") }}
    </span>
    <span
        class="bracket-type-badge bracket-type-badge-repechage-by-finalists"
        v-else-if="fight.bracketType === BracketTypeEnum.RepechageByFinalists"
    >
        {{ translate("category_label.repechage_by_finalists") }}
    </span>
    <span class="bracket-type-badge bracket-type-badge-round-robin" v-else-if="fight.bracketType === BracketTypeEnum.RoundRobin">
        {{ translate("category_label.round_robin") }}
    </span>
    <span
        class="bracket-type-badge bracket-type-badge-de-two-3rd-places"
        v-else-if="fight.bracketType === BracketTypeEnum.DoubleEliminationTwo3rdPlaces"
    >
        {{ translate("category_label.double_elemination_with_two_3rd_places") }}
    </span>
    <span
        class="bracket-type-badge bracket-type-badge-two-pools-two-3rd-places"
        v-else-if="fight.bracketType === BracketTypeEnum.TwoPoolsTwo3rdPlaces"
    >
        {{ translate("category_label.two_pools_two_3rd_places") }}
    </span>
    <span
        class="bracket-type-badge bracket-type-badge-de-one-3rd-place"
        v-else-if="fight.bracketType === BracketTypeEnum.DoubleEliminationOne3rdPlace"
    >
        {{ translate("category_label.double_elimination_one_3rd_place") }}
    </span>
    <span
        class="bracket-type-badge bracket-type-badge-two-pools-one-3rd-places"
        v-else-if="fight.bracketType === BracketTypeEnum.TwoPoolsOne3rdPlace"
    >
        {{ translate("category_label.two_pools_one_3rd_place") }}
    </span>
    <span class="bracket-type-badge bracket-type-badge-best-of-three" v-else-if="fight.bracketType === BracketTypeEnum.BestOfThree">
        B3
    </span>
    <span class="bracket-type-badge bracket-type-badge-kata" v-else-if="fight.bracketType === BracketTypeEnum.Kata">
        {{ translate("category_label.kata") }}
    </span>
</template>

<script setup lang="ts">
    import { translate } from "./translations";
    import { BracketType, BracketTypeEnum } from "./types";

    defineProps<{ fight: { bracketType: BracketType } }>();
</script>

<style scoped>
    /**
     * Fight category (bracket type) styles are generated via SCSS mixin in:
     * app/Frontend/Bulma/components/_bracket-type-badge.scss
     */
</style>
